import React from 'react'
import { Col, Row } from 'antd'
import { formatDateTime, formatDateWithoutTime, formatShippingTypes } from 'helpers/format'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { InfoItem } from 'Pages/Merchants/components'
import { SupplierOrderData } from 'Store/supplier-order/types'

type Props = {
  detail?: SupplierOrderData
}

const DeliveryInfo: React.FunctionComponent<Props> = props => {
  const { detail } = props

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  return (
    <BoxWrapper>
      <Row>
        <Col md={12} xs={24}>
          <BoxTitle>ข้อมูลที่อยู่ผู้รับ</BoxTitle>
          {renderInfo('ชื่อ', detail?.recipient_name)}
          {renderInfo('ที่อยู่', detail?.recipient_address)}
          {renderInfo('เบอร์โทรศัพท์', detail?.recipient_mobile)}
          {renderInfo('อีเมล', detail?.recipient_email)}
        </Col>
        <Col md={12} xs={24}>
          <BoxTitle>ข้อมูลการจัดส่ง</BoxTitle>
          {renderInfo('วันที่ต้องการให้จัดส่ง', formatDateWithoutTime(detail?.delivery_date || ''))}
          {renderInfo('ช่องทางจัดส่ง', formatShippingTypes(detail?.delivery_channel || ''))}
        </Col>
      </Row>
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

export default DeliveryInfo
